import { API } from '../../core/http/api'

export const getContactsLabels = async () => {
  const res = await API.get('contactlabels')
  if (res.status === 200) {
    return res.data.results.filter(label => label) || []
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}

export async function getContactsForLabelSet () {

}

export async function createContactLabel (contactlabel) {
  const res = await API.post('contactlabels', { name: contactlabel })
  if (res.status === 201) {
    return res.data || []
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}

export async function deleteContactLabel (contactlabel) {
  const res = await API.delete(`contactlabels/${contactlabel.composedid}`)
  if (res.status === 200) {
    return res.data.results || []
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}

export async function editExistingContactLabel (contactlabel) {
  const res = await API.put(`contactlabels/${contactlabel.composedid}`, contactlabel)

  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /contactlabels')
  return res.data
}

export async function setLabelsForContact (contact, labels) {
  const res = await API.put(`contacts/${contact.composedid}/labels`, {
    contactLabelIds: labels
  })

  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /contactlabels')

  return res.data
}
